import { useSenarioTemplateSet } from "components/scenarioManegement/ScenarioExpand/hook";
import { getChatData, getMail } from "graphql/queries";
import { PageLevel, useConsoleState } from "providers/ConsoleStateProvider";
import { useLoadingState } from "providers/LoadingProvider";
import React from "react";
import { useHistory } from "react-router";
import { Interview, Monitor, NotificationEvent } from "types/graphqlapi";
import { listInterviewsQuery } from "utils/apis/interview";
import { fetchMonitorBysubjectIdQuery } from "utils/apis/monitor";
import { fetchNotificationEventByInterviewIdQuery } from "utils/apis/notificationEvent";

export type DisplayInterviewWithNotificationEvent = {
  notificationEventList: NotificationEvent[] | [];
} & Interview;

export const useInterviewListWithNotificationEvents = (
  selectedSubjectId: string
) => {
  const history = useHistory();
  const { setLoading } = useLoadingState();
  const [displayInterviewList, setDisplayInterviewList] = React.useState<
    DisplayInterviewWithNotificationEvent[]
  >([]);

  const fetchInterviewListWithNotificationEvents = async () => {
    try {
      const queryResult = await listInterviewsQuery(selectedSubjectId);
      if (queryResult === undefined) return;

      const interviewWithNotificationEventList = await Promise.all(
        queryResult.map(
          async (interview): Promise<DisplayInterviewWithNotificationEvent> => {
            const notificationEvents =
              await fetchNotificationEventByInterviewIdQuery(interview.id);
            return {
              ...interview,
              notificationEventList: notificationEvents.filter(
                (notificationEvent) => notificationEvent.notification_event_type
              ),
            };
          }
        )
      );

      const sortedList = interviewWithNotificationEventList.sort((a, b) => {
        if (a.interview_seq < b.interview_seq) return -1;
        if (a.interview_seq > b.interview_seq) return 1;
        return 0;
      });
      setDisplayInterviewList(sortedList);
    } catch (e) {
      console.error(e);
      alert("エラーが発生しました。");
      setLoading(false);
      history.replace("/auth/login");
    }
  };

  React.useEffect(() => {
    fetchInterviewListWithNotificationEvents();
  }, []);

  return {
    displayInterviewList,
    setDisplayInterviewList,
    fetchInterviewListWithNotificationEvents,
  };
};

export const useMonitors = (subjectId: string) => {
  const history = useHistory();
  const { setLoading } = useLoadingState();
  const [monitorList, setMonitorList] = React.useState<Monitor[]>([]);

  const fetchMonitorList = async () => {
    try {
      const queryResult = await fetchMonitorBysubjectIdQuery(subjectId);

      if (queryResult === undefined) return;

      setMonitorList(queryResult);
    } catch (e) {
      console.error(e);
      alert("エラーが発生しました。");
      setLoading(false);
      history.replace("/auth/login");
    }
  };

  React.useEffect(() => {
    fetchMonitorList();
  }, []);

  return {
    monitorList,
    setMonitorList,
    fetchMonitorList,
  };
};
